









































































import {Component, Vue} from 'vue-property-decorator';
import MiniRhizome from "@/components/MiniRhizome.vue";

@Component({
  components: {
    MiniRhizome
  }
})

export default class AboutModal extends Vue {

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  close() {
    this.$store.dispatch('rhizome/closeAboutModal')
  }

  addPressedStyle(event) {
    if (this.isKiosk) {
      event.target.classList.add('pressed');
    }
  }

  removePressedStyle(event) {
    if (this.isKiosk) {
      event.target.classList.remove('pressed');
    }
  }
}
